import { acceptHMRUpdate, defineStore } from "pinia";
import {ref} from "vue";
import {useDialogManagerStore} from "@/stores/dialog-manager";
import {makePassenger, useBookingStore} from "@/stores/booking";
import LoginDialog from "@/common-components/dialogs/login-dialog.vue";

const show = ref(false);
export const useLoginDialogStore = defineStore('login-dialog', {
	state: () => ({
		// show: computed(() => { show.value }),
		loadingForm: false,
		formData: import.meta.env.DEV ? {
			name: 'ROMA',
			surname: 'TEST',
			cartafreccia: 121827412
		} : {
			name: null,
			surname: null,
			cartafreccia: null
		},
		formErrors: {
			name: '',
			surname: '',
			cartafreccia: ''
		},
		isLogged: false,
		userData: null,
		resolve: null,
		loading: false,
		settings: {
			persistent: true,
		},
		dialog: null
	}),
	getters: {
		show() {
			return show.value;
		},
	},
	actions: {
		setCustomerDataTopassenger(customer) {
			if (!this.userData) return ;
			let matrix = makePassenger();
			for (let k in matrix.data) {
				if (!Object.hasOwnProperty.call(matrix.data, k)) continue;
				matrix.data[k] = customer[k] || null
			}
			matrix.data.name = customer.firstName;
			matrix.data.surname = customer.lastName;
			if (customer.card.code){
				matrix.data.cartaFreccia = customer.card.code;
			}

			if (customer.contacts) {
				matrix.data.contact_consent = true;
				for (let contactK in customer.contacts) {
					if (!Object.hasOwnProperty.call(customer.contacts, contactK)) continue;
					let contact = customer.contacts[contactK];
					if ('MOBILE' == contact.contactType) {
						matrix.data.phoneNumber = contact.contactValue;
						matrix.data.contact_consent = false;
						matrix.disclaimers.cell = true;
					} else if ('EMAIL' == contact.contactType) {
						matrix.data.email = contact.contactValue;
						matrix.data.emailConf = contact.contactValue;
						matrix.data.contact_consent = false;
						matrix.disclaimers.email = true;
					}
				}
			}
			if(!matrix.data.type) matrix.data.type = 'ADULT';
			matrix.data.customerKey = customer.customerKey;
			matrix.data.customerId = customer.id;


			return matrix
		},
		async tryLogin(data=null) {
			this.settings.persistent = true;
			this.loading = true;

			return this.$axios.post('trenitalia/search-customer', this.formData)
			.then((response) => {
				if (!response.data) return false;

				if('true' == import.meta.env.VITE_CHANGE_CUSTOMEREMAIL) {
					if(!import.meta.env.VITE_TRAVELLER_EMAIL) throw new Error('Assegna una email a "VITE_TRAVELLER_EMAIL" nel file .env');
					for(const contact of response.data.customers.contacts) {
						if ('EMAIL' == contact.contactType) {
							contact.contactValue = import.meta.env.VITE_TRAVELLER_EMAIL;
							break;
						}
					}
				}

				this.userData = response.data;
				this.loading = false;
				this.isLogged = true;
				// sessionStorage.setItem('login', JSON.stringify(response.data));
				useBookingStore().resetTravellers(this.setCustomerDataTopassenger(this.userData.customers));
				//useDialogManagerStore().snackbar('LOGGED IN !')

				return true;
			}).catch(e => {
				this.loading = false;
				// if (e.response.data.message && (e.response.data.message.indexOf('Error with searchCustomers') >= 0 ||
				// 	e.response.data.message.indexOf('The given data was invalid') >= 0)) {
				// 	loginError.value = true;
				// } else {
				// 	this.loginError(e);
				// }
				return false;
			});
		},
		async login() {
			const dialogManager = useDialogManagerStore();
			this.dialog = await dialogManager.openSimpleMessageDialog({}, false, LoginDialog);

			if ('cancel' == this.dialog.result) {
				this.onlyClose();

				return false;
			} else if ('login' == this.dialog.result) {
				this.loadingForm = true;
				const res = await this.tryLogin();
				this.loadingForm = false;
				if (res) {
					this.onlyClose();
				} else {
					return this.loginError()
				}
			}
			await Promise.resolve(); // wait for getters to be updated

			return true;
		},
		onlyClose() {
			if (this.dialog) this.dialog.dialogData.removeDialog();
		},
		cancel() {
			this.onlyClose();
			this.$reset();
		},
		async loginError(e = false) {
			this.cancel();
			await useDialogManagerStore().openSimpleMessageDialog({
				title: this.$i18n.t('dialogs.warning'),
				titleAlign: 'center',
				text: this.$i18n.t('stores.uselogindialog.auth_error', 'C\'è stato un errore nella fase di autenticazione, per favore riprovare.'),
				textAlign: 'center',
				messageType: 'warning'
			}, true);

			await this.login();

			return ;
		},
		logout() {
			sessionStorage.removeItem('login');
			this.cancel();
		}
	}
});

if(import.meta.hot){
	import.meta.hot.accept(acceptHMRUpdate(useLoginDialogStore, import.meta.hot));
}